import $ from "jquery";
import ko from "knockout";

function UlyPreferences() {
}
UlyPreferences.prototype.fetch = function(key) {
    var result = Promise.Deferred();
    try {
        var val = localStorage.getItem(key);
        val = JSON.parse(val);
        result.resolve(val);
    }
    catch(e) {
        result.reject(e);
    }
    return result;
};

UlyPreferences.prototype.store = function(key, value) {
    var result = Promise.Deferred();
    try {
        var val = ko.toJSON(value);
        localStorage.setItem(key, val);
        result.resolve();
    }
    catch(e) {
        result.reject(e);
    }
    return result;
};

export default new UlyPreferences();
